import React from 'react';

const About = () => {
  return (
      <div>
          <h1 className="display-4">About Contact Manager</h1>
          <p className="lead">Simple app to manage contacts</p>
          <p className="text-secondary">Version 1.0.0</p>
      </div>
    );
}

export default About;



// WEBPACK FOOTER //
// ./src/components/pages/About.js